/**
 * @desc 根据spuId获取spu详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlmSpuDetailResponseDto>;
export function request(spuId: number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/spu/${spuId}`, {
      method: "GET",

      ...options,
    }),
  );
}
